import React, { useContext } from 'react';
import ProcanvasSlider from '../../../../../common/procanvasSlider';
import { MarkupContext } from '../../../contexts';

const ThresholdSlider = () => {
  const { threshold, updateThreshold } = useContext(MarkupContext);
  return (
    <div className="form-group -lg3">
      <div className="form-label">Threshold:</div>
      <div className="form-group">
        <ProcanvasSlider
          min={ 1 }
          max={ 100 }
          step={ 1 }
          value={ threshold }
          onChange={ updateThreshold }
        />
      </div>
    </div>
  );
};

export default ThresholdSlider;
